import { Flex } from "metabase/ui";

import {
  AdminContent,
  AdminMain,
  AdminSidebar,
  AdminWrapper,
} from "./AdminLayout.styled";

interface AdminLayoutProps {
  sidebar?: React.ReactNode;
  children: React.ReactNode;
  upsell?: React.ReactNode;
  headerHeight?: number;
}

export function AdminLayout({
  sidebar,
  children,
  headerHeight,
  upsell,
}: AdminLayoutProps) {
  return (
    <AdminWrapper headerHeight={headerHeight}>
      <AdminMain>
        {sidebar && (
          <AdminSidebar data-testid="admin-layout-sidebar">
            {sidebar}
          </AdminSidebar>
        )}
        <AdminContent data-testid="admin-layout-content">
          {upsell ? (
            <Flex justify="space-between" w="100%">
              {children}
              {upsell}
            </Flex>
          ) : (
            children
          )}
        </AdminContent>
      </AdminMain>
    </AdminWrapper>
  );
}
